<kendo-dialog *ngIf="dialogOpened" (close)="close();" [width]="400">
    <kendo-dialog-titlebar>
        <h3>{{ 'ACTIVE-ROLES' | translate}}</h3>
    </kendo-dialog-titlebar>
    <div class="mt-2">
        <label class="k-form-field w-100">
            <span class="k-text-uppercase dark">{{ 'SELECT-ROLE' | translate }}</span>
            <kendo-dropdownlist [(ngModel)]="selectedRole" class="w-100" [valuePrimitive]="true" [data]="activeRoles"
                [textField]="'text'" [valueField]="'value'" [ngModelOptions]="{standalone: true}">
            </kendo-dropdownlist>
        </label>
    </div>
    <kendo-dialog-actions>
        <button kendoButton #selectButton (click)="select()">{{ 'SELECT' | translate }}<i class="fal fa-user-check"></i>
        </button>
    </kendo-dialog-actions>
</kendo-dialog>